import collectionSearch from 'utilities/collectionSearch';

const SEARCH_KEYS = ['name', 'year', 'employer'];

export default (collection, searchText) => {
  if (searchText.length < 2) return collection;
  return collectionSearch({ collection, searchText, searchKeys: SEARCH_KEYS });
};
